export const linksData = [
  {
    name: "Linkedin",
    link: "https://www.linkedin.com/in/dejannadoba95",
    icon: <i className="fa-brands fa-linkedin"></i>,
  },

  {
    name: "Github",
    link: "https://github.com/Nadoba95",
    icon: <i className="fa-brands fa-github"></i>,
  },

  {
    name: "Instagram",
    link: "https://www.instagram.com/nadoba.d/",
    icon: <i className="fa-brands fa-instagram"></i>,
  },

  {
    name: "Facebook",
    link: "https://sr-rs.facebook.com/dejan.nadoba",
    icon: <i className="fa-brands fa-facebook"></i>,
  },
];
